export const getOrderPrefix = requestFor => {
  switch (requestFor) {
    case "quote":
      return "QT-"
      break
    case "order":
      return "OR-"
      break
    case "vector":
      return "VO-"
      break
    default:
      break
  }
}

export const getDateString = (date) => {
  let unix_timestamp = date
  var date = new Date(unix_timestamp);
  return date.toLocaleDateString("en-US");
}
export const chicagoDateTime = () => {
  return Date.now( new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }))
}
